import Controller from "./backups.controller";
import template from "./backups.html";

const backups = {
  template,
  controller: Controller,
};

export default backups;



// WEBPACK FOOTER //
// ./src/pages/backups/backups.component.js